import { mapGetters, mapActions } from 'vuex'

export const Computed = {
  ...mapGetters('infoDetails', [
    'selectedDefaultObject',
    'selectedDetailsDevice',
    'selectedDetailsDeviceStateHistory',
    'selectedDetailsDeviceStateHistoryDetail',
    'selectedDetailsDeviceStateHistoryDetailCondition',
    'selectedDetailsAction',
    'selectedDetailsInsight',
    'selectedDetailsInteractCycle',
    'selectedDetailsInteractActivity',
    'selectedDetailsInteractActivityHistorical',
  ]),
}

export const Methods = mapActions('infoDetails', ['selectDetailsDefault'])
